var map = {
	"./esenin/1.jpg": 3123,
	"./esenin/2.jpg": 5110,
	"./esenin/3.jpg": 8213,
	"./esenin/4.jpg": 6577,
	"./esenin/5.jpg": 1032,
	"./esenin/6.jpg": 3849,
	"./physics/1.jpg": 4862,
	"./physics/2.jpg": 7769,
	"./physics/3.jpg": 2746,
	"./physics/4.jpg": 7170,
	"./physics/5.jpg": 8573,
	"./physics/6.jpg": 9685,
	"./physics/7.jpg": 118,
	"./physics/8.jpg": 566,
	"./pt-academy/1.jpg": 7884,
	"./pt-academy/2.jpg": 5207,
	"./pt-academy/3.jpg": 8461,
	"./pt-academy/4.jpg": 2993,
	"./pt-academy/5.jpg": 1416,
	"./pt-academy/6.jpg": 7849,
	"./pt-game/1.jpg": 8050,
	"./pt-game/2.jpg": 3728,
	"./pt-game/3.jpg": 5671,
	"./pt-game/4.jpg": 447,
	"./pt-game/5.jpg": 7105,
	"./pt-game/6.jpg": 5261,
	"./pt-game/7.jpg": 7430,
	"./pt-mobile/1.jpg": 2881,
	"./pt-mobile/2.jpg": 8678,
	"./pt-mobile/3.jpg": 3237,
	"./pt-mobile/4.jpg": 7071,
	"./pt-mobile/5.jpg": 6362,
	"./pt-mobile/6.jpg": 5950,
	"./pt-web/1.jpg": 6580,
	"./pt-web/2.jpg": 9701,
	"./pt-web/3.jpg": 5310,
	"./pt-web/4.jpg": 6905,
	"./pt-web/5.jpg": 2548,
	"./pt-web/6.jpg": 2709,
	"./universe-say/1.jpg": 5600,
	"./universe-say/2.jpg": 7125,
	"./universe-say/3.jpg": 3013,
	"./universe-say/4.jpg": 8968,
	"./universe-say/5.jpg": 6217,
	"./universe-say/6.jpg": 6281,
	"./universe-say/7.jpg": 5919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 440;